export function isPromise(obj: unknown): obj is Promise<unknown> {
  return !!(
    obj instanceof Promise ||
    (typeof obj === "object" && obj && "then" in obj && typeof obj.then === "function")
  )
}
